import { RightChevron } from '../../../asset/icons';

export default function OrderDeliveryStatus({ orderDeliveryStatus }) {
  console.log(
    '🚀 ~ OrderDeliveryStatus ~ orderDeliveryStatus:',
    orderDeliveryStatus,
  );

  const statusList = [
    { label: '결제완료', count: orderDeliveryStatus.paymentCompleted },
    { label: '상품준비중', count: orderDeliveryStatus.preparing },
    { label: '배송중', count: orderDeliveryStatus.shipping },
    { label: '배송완료', count: orderDeliveryStatus.delivered },
  ];

  return (
    <section>
      <div className='text-gray-50 pt-6 text-xs text-right'>
        최근 3개월동안 구매한 상품
      </div>

      <ul className='flex items-center justify-between text-center pt-6 pb-5'>
        {statusList.map((status, idx) => (
          <div key={idx} className='flex-1 relative'>
            <li className='text-lg md:text-3xl font-semibold font-inter text-gray-50'>
              {status.count}
            </li>
            <li className='md:mt-2 text-sm md:text-lg font-medium text-foreground'>
              {status.label}
            </li>
            {status.label !== '배송완료' && (
              <li className='absolute right-0 top-1/2 transform translate-x-1/2 -translate-y-1/2'>
                <RightChevron className='w-6 h-6  md:w-8 md:h-8 ' />
              </li>
            )}
          </div>
        ))}
      </ul>
    </section>
  );
}
